// extracted by mini-css-extract-plugin
export default {"app":"app__nHl0f","text-center":"text-center__gITeg","error-color":"error-color__IAmIQ","loading":"loading__utNj9","wrapper":"wrapper__tZLCa","icon":"icon__DYKag"};